import TheGrid from '@/views/emailtemplates/grid'
import Edit from '@/views/emailtemplates/edit'
import TheView from '@/views/emailtemplates/view'

export default {
  path: '/email/templates',
  redirect: '/email/templates/index',
  name: 'emailtemplates',
  meta: {
    auth: {
      redirect: {
        name: 'emailtemplates.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Templates de email'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'emailtemplates.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'emailtemplates.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'emailtemplates.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'emailtemplates.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
